import React from "react";
import { useDispatch } from "react-redux";
import { useReduxAccount } from "../../hooks";
import { setAccount } from "../../store/panel";
import * as API from "../../lib/api";

export default function Logout() {
    const dispatch = useDispatch();
    const account = useReduxAccount();

    React.useEffect(() => {
        if (!account) {
            return;
        }

        API.Send("/account/logout").then(() => {
            dispatch(setAccount(null));
            window.location = "/";
        });
    }, [account]);

    return null;
}
